export default class HeaderDropdown {

    constructor() {
        if(this.dropdownTrigger = document.querySelector(".pageheader-personal-content")) {
            this.pageOverlay = document.querySelector(".page-overlay")
            this._handleClicks()
        }
    }

    _handleClicks() {
        window.addEventListener("click", (e) => {
            if (this.dropdownTrigger.contains(e.target)) {
                e.preventDefault()
                document.body.classList.add("overlay-active")
                document.body.classList.add("dropdown-active")
            }

            else if (e.target === this.pageOverlay) {
                document.body.classList.remove("overlay-active")
                document.body.classList.remove("dropdown-active")
            }
        })
    }
}